'use client';

import { useEffect } from 'react';
import { signIn } from 'next-auth/react';

export const LoginComponent = () => {
  useEffect(() => {
    void signIn();
  }, []);

  return null;
};
